export default {"src":"/_next/static/media/calendar.6bde4f06.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};